import type React from 'react';

import { useUpdateEffect } from '@xing-com/crate-entity-pages-common';
import { IconStar } from '@xing-com/icons';

import { useFeatureArticleMutation } from '../../../../hooks/use-feature-article-mutation';
import * as Styled from '../article-card-top.styles';

import type { ArticleControlButton } from './types';

export const ArticleFeatureButton: React.FC<ArticleControlButton> = ({
  article,
  disabled,
  onLoadingChange,
  onCompleted,
  onError,
}) => {
  const [makeAritcleFeatured, { loading }] = useFeatureArticleMutation();

  useUpdateEffect(() => {
    onLoadingChange(loading);
  }, [loading]);

  const handleClick = () => {
    makeAritcleFeatured({
      variables: { input: { globalId: article.globalId } },
      onCompleted,
      onError,
    });
  };

  return (
    <Styled.Button
      data-testid={`ARTICLE-FEATURE-BUTTON-${article.id}`}
      icon={IconStar}
      size="small"
      variant="tertiary"
      disabled={disabled}
      loading={loading}
      onClick={handleClick}
    />
  );
};
